import React from "react";
import { Tag } from "antd";
import { arrComparer, removeDupes } from "../../../../api/util";
import { fetchJsData } from "../../../../api";
import { isArray } from "lodash";

export const newApps = (leng) => {
  return [
    {
      title: () => {
        return (
          <>
            App Name <Tag color="processing">{leng}</Tag>
          </>
        );
      },
      dataIndex: "current_name",
      key: "current_name",
      fixed: "left",
      sorter: (a, b) =>
        a.current_name ? a.current_name.localeCompare(b.current_name) : 1,
      // responsive: ["sm"],
      width: "30%",
    },
    {
      title: "Domains",
      dataIndex: "domain_name",
      key: "domain_name",
      fixed: "left",
      // responsive: ["sm"],
      width: "30%",
      ellipsis: true,
      render: (text) => {
        return <>{isArray(text) ? text.join(", ") : text}</>;
      },
    },
    {
      title: "Old Category",
      dataIndex: "old_category",
      key: "old_category",
      fixed: "left",
      sorter: (a, b) =>
        a.old_category ? a.old_category.localeCompare(b.old_category) : 1,
      // responsive: ["sm"],
      width: "20%",
    },
    {
      title: "New Category",
      dataIndex: "new_category",
      key: "new_category",
      fixed: "left",
      sorter: (a, b) =>
        a.new_category ? a.new_category.localeCompare(b.new_category) : 1,
      // responsive: ["sm"],
      width: "20%",
    },
  ];
};

export const fetchUserSearch = async (rel, prevRel, sel, modVal) => {
  try {
    const start = Date.now();
    const modData = modVal;
    // extract release info
    let newData = modData;

    // const millis = Date.now() - start;
    console.log(`data fetched = ${Math.floor((Date.now() - start) / 1000)}`);

    const data = await fetchJsData({
      type: "fetch",
      qry: "fetCciCatChng",
      firstVal: "snapshot_v" + rel + "_0_0",
      secondVal: "snapshot_v" + rel + "_0_0",
      thirdVal: "snapshot_v" + rel + "_0_0",
      fourthVal: "snapshot_v" + rel + "_0_0",
      fifthVal: "snapshot_v" + rel + "_0_0",
      sixthVal: "snapshot_v" + prevRel + "_0_0",
      seventhVal: "snapshot_v" + prevRel + "_0_0",
    });

    console.log(`data fetched = ${Math.floor((Date.now() - start) / 1000)}`);

    console.log("data", data["data"].length);
    // return { success: 1, data: data };

    const arr = data["data"].reduce((acc, item) => {
      const found = acc.find((i) => i.current_name === item.current_name);

      if (found) {
        found.domain_name.push(item.domain_name);
      } else {
        acc.push({
          current_name: item.current_name,
          old_category: item.old_category,
          new_category: item.new_category,
          customtag: item.customtag.includes("p1") ? "P1" : "P2",
          domain_name: [item.domain_name],
        });
      }

      return acc;
    }, []);

    return { success: 1, data: arr };
  } catch (error) {
    console.error(error);
    return "";
  }
};

export const tabPageCss = {
  padding: "0",
  marginBottom: "0",
};

export const cardCss = { padding: "0", borderStyle: "hidden" };

// const arr = data["data"].reduce((acc, item) => {
//   const found = acc.find((i) => i.current_name === item.current_name);

//   if (found) {
//     found.names.push(item.names);
//   } else {
//     acc.push({
//       current_name: item.current_name,
//       old_category: item.old_category,
//       new_category: item.new_category,
//       customtag: item.customtag,
//       domain_name: [item.domain_name],
//     });
//   }

//   return acc;
// }, []);
